import React from 'react'
import { HiDotsVertical } from 'react-icons/hi'

const AssetSpot = () => {
  return (
    <>
    <div className="p-6 space-y-6 w-full">
      {/* Estimated Balance Card */}
      <div className="p-6 rounded-xl shadow-sm flex justify-between items-center w-full">
        <div>
          <h2 className="text-sm font-semibold text-gray-600 flex items-center">
            Estimated Balance 
          </h2>
          <div className="text-3xl font-bold">0.00 <span className="text-base font-medium">BTC</span></div>
          <div className="text-sm text-gray-500">≈ $0.00</div>
          <div className="text-xs text-gray-400 mt-1">
            Today's PnL <span className="ml-1">+ $0.00 (0.00%)</span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button className="bg-gray-100 text-sm px-4 py-1 rounded shadow hover:bg-gray-200">Deposit</button>
          <button className="bg-gray-100 text-sm px-4 py-1 rounded shadow hover:bg-gray-200">Withdraw</button>
          <button className="bg-gray-100 text-sm px-4 py-1 rounded shadow hover:bg-gray-200">Transfer</button>
          <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer ml-2" />
        </div>
      </div>

      {/* Spot Table */}
      <div className="bg-white p-6 rounded-xl shadow-sm w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Spot</h2>
          <div className="flex items-center gap-3">
            <input type="text" placeholder="🔍" className="border px-2 py-1 text-sm rounded w-8" />
            <button className="text-sm text-gray-600">Small Amount Exchange ↔</button>
            <label className="text-sm flex items-center gap-1">
              <input type="checkbox" />
              Hide assets &lt; 1 USD
            </label>
          </div>
        </div>

        {/* Table Header */}
        <div className="grid grid-cols-5 text-xs font-semibold text-gray-400 border-b py-2">
          <div>Coin</div>
          <div>Amount</div>
          <div>Available</div>
          <div></div>
          <div>Action</div>
        </div>

        {/* Row 1 - BTC */}
        <div className="grid grid-cols-5 items-center py-4 border-b text-sm text-gray-800">
          <div className="flex items-center gap-2">
            <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.png?v=026" alt="BTC" className="w-6 h-6" />
            <div>
              <div className="font-semibold">BTC</div>
              <div className="text-xs text-gray-500">Bitcoin</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">0.00</div>
            <div className="text-xs text-gray-500">$0.00</div>
          </div>
          <div>0.00</div>
          <div className="flex gap-3">
            <button className="text-sm text-blue-600 underline">Convert</button>
            <button className="text-sm text-blue-600 underline">Earn</button>
          </div>
          <div>
            <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
          </div>
        </div>

        {/* Row 2 - ETH */}
        <div className="grid grid-cols-5 items-center py-4 border-b text-sm text-gray-800">
          <div className="flex items-center gap-2">
            <img src="https://cryptologos.cc/logos/ethereum-eth-logo.png?v=026" alt="ETH" className="w-6 h-6" />
            <div>
              <div className="font-semibold">ETH</div>
              <div className="text-xs text-gray-500">Ethereum</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">0.00</div>
            <div className="text-xs text-gray-500">$0.00</div>
          </div>
          <div>0.00</div>
          <div className="flex gap-3">
            <button className="text-sm text-blue-600 underline">Convert</button>
            <button className="text-sm text-blue-600 underline">Earn</button>
          </div>
          <div>
            <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
          </div>
        </div>

        {/* Row 3 - BNB */}
        <div className="grid grid-cols-5 items-center py-4 border-b text-sm text-gray-800">
          <div className="flex items-center gap-2">
            <img src="https://cryptologos.cc/logos/bnb-bnb-logo.png?v=026" alt="BNB" className="w-6 h-6" />
            <div>
              <div className="font-semibold">BNB</div>
              <div className="text-xs text-gray-500">BNB</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">0.00</div>
            <div className="text-xs text-gray-500">$0.00</div>
          </div>
          <div>0.00</div>
          <div className="flex gap-3">
            <button className="text-sm text-blue-600 underline">Convert</button>
            <button className="text-sm text-blue-600 underline">Earn</button>
          </div>
          <div>
            <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
          </div>
        </div>

        {/* Row 4 - USDT */}
        <div className="grid grid-cols-5 items-center py-4 text-sm text-gray-800">
          <div className="flex items-center gap-2">
            <img src="https://cryptologos.cc/logos/tether-usdt-logo.png?v=026" alt="USDT" className="w-6 h-6" />
            <div>
              <div className="font-semibold">USDT</div>
              <div className="text-xs text-gray-500">TetherUS</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">0.00</div>
            <div className="text-xs text-gray-500">$0.00</div>
          </div>
          <div>0.00</div>
          <div className="flex gap-3">
            <button className="text-sm text-blue-600 underline">Convert</button>
            <button className="text-sm text-blue-600 underline">Earn</button>
          </div>
          <div>
            <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default AssetSpot